import React from 'react';
import PropTypes from 'prop-types';

const HelpBlock = ({text, type}) => {
  const classes = type === 'error' ? 'help-block with-errors' : 'help-block';
  return (
    <div className={classes}>
      {text}
    </div>
  );
};

HelpBlock.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(['error', 'success']).isRequired
};

export default HelpBlock;



// WEBPACK FOOTER //
// ./src/components/forms/HelpBlock.js